import type { VFC } from 'react';

import classNames from 'classnames';

import * as styles from './Spinner.module.scss';

export type SpinnerProps = {
  size?: 'big' | 'small';
};

export const Spinner: VFC<SpinnerProps> = ({ size = 'big' }) => {
  return (
    <div
      className={classNames(styles.spinner, {
        [styles.big]: size === 'big',
        [styles.small]: size === 'small',
      })}
    >
      <div className={styles.blade1} />
      <div className={styles.blade2} />
      <div className={styles.blade3} />
      <div className={styles.blade4} />
      <div className={styles.blade5} />
      <div className={styles.blade6} />
      <div className={styles.blade7} />
      <div className={styles.blade8} />
      <div className={styles.blade9} />
      <div className={styles.blade10} />
      <div className={styles.blade11} />
      <div className={styles.blade12} />
    </div>
  );
};
